import { useState } from 'react'

import { useDebouncedSearch } from '../../../../../hooks'
import { getNextFilterParamsFromPostListItems } from '../../../../Post'
import {
  ENTITY_TAB_POSTS_DEFAULT_ORDERING_VALUE,
  ENTITY_TAB_POSTS_ORDERING_OPTIONS,
  ENTITY_TAB_POSTS_SEARCH_TIMEOUT,
} from '../../EntityTabPosts.constants'

import {
  getEntityTabPostsApiParams,
  getEntityTabPostsBaseFilters,
} from './useEntityTabPostsListParams.utils'

export function useEntityTabPostsListParams({
  filterValues,
  scopeFilterKey,
  scopeId,
}) {
  const [orderingValue, setOrderingValue] = useState(
    ENTITY_TAB_POSTS_DEFAULT_ORDERING_VALUE
  )

  const { debouncedSearch, handleChangeSearch, handleClearSearch, search } =
    useDebouncedSearch(ENTITY_TAB_POSTS_SEARCH_TIMEOUT)

  const apiParams = getEntityTabPostsApiParams({
    filterValues,
    ordering: ENTITY_TAB_POSTS_ORDERING_OPTIONS[orderingValue],
    scopeFilterKey,
    scopeId,
    searchQuery: debouncedSearch,
  })

  function getNextApiParams(items) {
    return getNextFilterParamsFromPostListItems(
      items,
      getEntityTabPostsBaseFilters({
        filterValues,
        scopeFilterKey,
        scopeId,
        searchQuery: debouncedSearch,
      })
    )
  }

  function handleSelectOrdering(option) {
    setOrderingValue(option.value)
  }

  return {
    apiParams,
    debouncedSearch,
    getNextApiParams,
    handleChangeSearch,
    handleClearSearch,
    handleSelectOrdering,
    orderingValue,
    search,
  }
}
